module.exports = __webpack_public_path__ + "img/windows.f743207.svg";